function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling && summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.input.addEventListener("change", this.onInputChange.bind(this))
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();//to stop trigering bin click
        event.stopPropagation();

        const cartItems = this.input.closest("cart-items");
        if (cartItems) {
          const changeEvent = new Event('change');
          cartItems.dispatchEvent(changeEvent);
        }
      }
    });
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onInputChange(event) {
    if (!this.input.value || this.input.value == 0) {
      this.input.value = 1;
    }

  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/**
 * Add a single variant to cart from a product card quick-add button (skips modal/popup).
 */
window.addVariantToCartFromCard = async function (btn, variantId) {
  if (!btn || !variantId) return;

  const loader = btn.querySelector('span');
  const originalLabel = btn.dataset.buttonLabel || (loader ? loader.textContent.trim() : '');

  if (loader) {
    loader.textContent = '';
    loader.classList.add('bundle-atc-loader');
  }
  btn.setAttribute('aria-disabled', 'true');

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
    const data = await response.json();

    if (!response.ok || data.status) {
      throw new Error(data.description || 'Add to cart failed');
    }

    if (typeof window.loadCartAPI === 'function') {
      window.loadCartAPI(true);
    }
  } catch (err) {
    console.error(err);
    alert('There was an error adding the product to the cart.');
  } finally {
    btn.removeAttribute('aria-disabled');
    if (loader) {
      loader.textContent = originalLabel;
      loader.classList.remove('bundle-atc-loader');
    }
  }
};

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};


Shopify.loadElements = function (data, selectors, parent = document) {
  Object.keys(selectors).forEach(key => {
    if (key[0] === '#') {
      data[key] = parent.getElementById(selectors[key].substring(1));
    }
    else if (key.slice(-1) === 's') {
      data[key] = parent.querySelectorAll(selectors[key]);
    }
    else {
      data[key] = parent.querySelector(selectors[key]);
    }
  });
};

Shopify.money_format = money_format;
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.querySelectorAll('[data-tabbed="true"]').forEach(tabGroup => tabGroup.addEventListener('keyup', this.horizontalTabOnKeyup.bind(this)));
    this.querySelectorAll('[aria-orientation="vertical"]').forEach(verticalTabGroup => verticalTabGroup.addEventListener('keyup', this.verticalTabOnKeyup.bind(this)));

  }
  verticalTabOnKeyup() {
    if (event.key == 'ArrowUp') {
      let previousButton = event.target.closest('li').previousElementSibling;
      previousButton.querySelector('summary').focus();
    }
    else if (event.key == 'ArrowDown') {
      let nextButton = event.target.closest('li').nextElementSibling;
      nextButton.querySelector('summary').focus();
    }
  }
  horizontalTabOnKeyup() {
    if (event.key == 'ArrowLeft') {
      let previousButton = event.target.closest('li').previousElementSibling;
      previousButton.querySelector('summary').focus();
    }
    else if (event.key == 'ArrowRight') {
      let nextButton = event.target.closest('li').nextElementSibling;
      nextButton.querySelector('summary').focus();
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const currentId = detailsElement.dataset.toggleId;

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    }
    else if (currentId) {
      if (detailsElement.open) {
        event.preventDefault();
        summaryElement.open = true;
      }
      else {
        let parent = summaryElement.closest('ul');
        let siblings = parent.querySelectorAll(`details:not([data-toggle-id="${currentId}"]`);
        siblings.forEach(details => details.open = false);
        summaryElement.open = true;
      }

    }
    else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.documentElement.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.classList.remove('menu-opening');
      this.closeAnimation(details);
    });

    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });

    document.documentElement.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.documentElement.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    // this.addEventListener('keyup', (event) => {
    //   if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    // });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    // window.pauseAllMedia();
  }

  hide() {
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    // window.pauseAllMedia();
    document.querySelector('body').classList.remove('popup-freeze');
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    /** Desktop drag to scroll */
    let isDown = false;
    let startX;
    let scrollLeft;
    this.slider.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - this.slider.offsetLeft;
      scrollLeft = this.slider.scrollLeft;
    });
    this.slider.addEventListener('mouseleave', () => {
      isDown = false;
    });
    this.slider.addEventListener('mouseup', () => {
      isDown = false;
    });
    this.slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - startX) * 3;
      this.slider.scrollLeft = scrollLeft - walk;
    });
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) return;
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = false;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    let sel = e.target;

    if (sel && sel.options && sel.selectedIndex >= 0) {
      const selectedOptionText = sel.options[sel.selectedIndex]?.text || '';

      if (selectedOptionText.includes('SOLD OUT')) {
        this.toggleAddButton(true, window.variantStrings.soldOut);
      } else {
        this.toggleAddButton(false, '', false);
      }
    } else {
      console.warn('Invalid select element or options in onVariantChange', sel);
    }

    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateMedia();
      this.updateSlider();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    setTimeout(() => {
      let buttonProduct = document.querySelector('button.product-form__submit.button.button--full-width.button--secondary');
      let headerProduct = document.querySelector('.js-sticky-product-add');

      if (buttonProduct && headerProduct) {
      if (buttonProduct.disabled) {
          headerProduct.classList.add('sticky-product-add--remove');
        }
        else {
          headerProduct.classList.remove('sticky-product-add--remove');
        }
      }
  }, 1000);
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);

    if (document.querySelector('.product-form__input--flavour')) {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      const secondOpt = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });

      if (this.options[0]) {
        this.options = [this.options[0], secondOpt[0]];
      } else {
        this.options = secondOpt;
      }
    }

  }

  updateMasterId() {
    const variantData = this.getVariantData();
    if (!variantData) {
      console.error('No variant data available');
      return;
    }

    this.currentVariant = variantData.find((variant) => {
      return variant.options.every((option, index) => this.options[index] === option);
    });

    if (!this.currentVariant) {
      console.warn('Variant not found. Reversing options for lookup.');
      this.options.reverse();
      this.currentVariant = variantData.find((variant) => {
        return variant.options.every((option, index) => this.options[index] === option);
      });
    }
  }

  updateSlider() {
    if (!this.currentVariant) return;

    const slider = document.querySelector(".js-flavour-container");
    if (!slider) return;

    const slides = slider.querySelectorAll(".swiper-slide");
    slides.forEach((slide) => {
      slide.classList.remove("flavour--selected");
    })

    for (let option of this.options) {
      const input = document.querySelector(`.js-flavour-container input[value="${option}"]`);
      if (input) {
        input.parentElement.classList.add("flavour--selected")
      }
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (mediaGallery) {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    document.dispatchEvent( new CustomEvent("variantChanged", { detail: { variantId: this.currentVariant.id } }) );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    document.dispatchEvent( new CustomEvent("variantChanged", { detail: { variantId: this.currentVariant.id } }) );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const sticky_destination = document.querySelector(`sticky-product-add .sticky-product-info--price`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && sticky_destination) sticky_destination.innerHTML = source.innerHTML;

        const variantSelectorsDestination = document.querySelector("[data-standard-variants-selectors]");
        const variantSelectorsSource = html.querySelector("[data-standard-variants-selectors]");
        if (variantSelectorsSource && variantSelectorsDestination) variantSelectorsDestination.innerHTML = variantSelectorsSource.innerHTML;    
        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        // let vectorbgDestination = document.querySelector(".background-vector");
        // let vectorbgSource = html.querySelector(".background-vector");
        // if (vectorbgDestination && vectorbgSource) {
        //   vectorbgDestination.innerHTML = vectorbgSource.innerHTML
        // }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {

    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('.product-form__submit');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    const notifyButton = productForm.querySelector('.klaviyo-bis-trigger');

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (notifyButton) notifyButton.classList.remove('hidden');
      addButton.classList.add('hidden');
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if (notifyButton) notifyButton.classList.add('hidden');
      addButton.classList.remove('hidden');
    }

    const productModal = document.getElementById('product-modal');
    const modalBody = productModal?.querySelector('#modal-body');
    if (modalBody?.contains(productForm) && typeof window.updateModalSoldOutButtons === 'function') {
      window.updateModalSoldOutButtons(modalBody);
      return;
    }

    //additional logic if klaviyo notifyMe
    const klaviyoNtfMe = document.querySelector('a.klaviyo-bis-trigger');
    let int = setInterval(function () {
      if (klaviyoNtfMe) {
        if (!klaviyoNtfMe.style.display) {
          clearInterval(int);
        }
      }
    }, 5)
    setTimeout(function () { clearInterval(int) }, 150);

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    //console.log('Variant Data:', this.variantData);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class VariantDropdownRadios extends VariantSelects {
  constructor() {
    super();

    this.topContainer = this.closest('variant-dropdown-radios');
    if (!this.topContainer) {
      console.error('VariantDropdownRadios: No top container found');
      return;
    }

    const variantsDataElement = this.topContainer.querySelector('script[type="application/json"]');
    if (variantsDataElement) {
      this.variants = JSON.parse(variantsDataElement.textContent);
    } else {
      console.error('VariantDropdownRadios: No variant data found in JSON');
    }

    this.addEventListener('click', this.handleClick.bind(this));
    this.bindBackdropAndCloseEvents();
  }

  handleClick(event) {
    const closeButton = event.target.closest('.drawer__close');
    const button = event.target.closest('.variant-select-button');

    if (closeButton) {
      this.closeAllDrawers();
      return;
    }

    if (button) {
      this.toggleDrawer(button);
      return;
    }
  }

  toggleDrawer(button) {
    const wrapper = button.closest('.variant-dropdown-container');
    if (!wrapper) {
      console.error('No wrapper found for toggleDrawer');
      return;
    }

    const isOpen = wrapper.classList.contains('open');
    this.closeAllDrawers();

    if (!isOpen) {
      wrapper.classList.add('open');
      document.body.classList.add('variants-modal-open');
      document.querySelector('#shopify-section-header')?.classList.add('shopify-section-header-hidden');
      this.bindBackdropAndCloseEvents();
    } else {
      wrapper.classList.remove('open');
      document.body.classList.remove('variants-modal-open');
    }
  }

  closeAllDrawers() {
    const wrappers = this.topContainer.querySelectorAll('.variant-dropdown-container');
    wrappers.forEach((wrapper) => {
      wrapper.classList.remove('open');
    });
    document.body.classList.remove('variants-modal-open');
    document.querySelector('#shopify-section-header')?.classList.remove('shopify-section-header-hidden');
  }

  bindBackdropAndCloseEvents() {
    const backdrops = this.topContainer.querySelectorAll('.backdrop');
    backdrops.forEach((backdrop) => {
      backdrop.removeEventListener('click', this.backdropClickHandler);
      backdrop.addEventListener('click', this.backdropClickHandler);
    });

    const closeButtons = this.topContainer.querySelectorAll('.drawer__close');
    closeButtons.forEach((button) => {
      button.removeEventListener('click', this.closeAllDrawers);
      button.addEventListener('click', this.closeAllDrawers);
    });
  }

  backdropClickHandler = () => {
    this.closeAllDrawers();
  };

  updateOptions() {
    const sizeSelect = this.topContainer.querySelector('select[name="options[Size]"]')?.value;
    const servesSelect = this.topContainer.querySelector('select[name="options[Serves]"]')?.value;
    const servingSizeSelect = this.topContainer.querySelector('select[name="options[Serving Size]"]')?.value;

    const selectedTopOption = sizeSelect || servesSelect || servingSizeSelect;

    const flavorRadios = Array.from(this.topContainer.querySelectorAll('.variant-radio-buttons-drawer input[type="radio"]'));
    const selectedFlavor = flavorRadios.find((radio) => radio.checked)?.value;

    // Update the options array based on the selected top option
    this.options = [selectedTopOption, selectedFlavor];

    //console.log('Updated options:', this.options);
  }

  updateMasterId() {
    super.updateMasterId();

    if (!this.currentVariant) return;

    const selectedImage = this.topContainer.querySelector('.selected-option-image');
    if (selectedImage && this.currentVariant.featured_image) {
      selectedImage.src = this.currentVariant.featured_image.src;
    }

    this.toggleAddButton(!this.currentVariant.available, this.currentVariant.available ? '' : 'Sold Out');
  }

  handleFlavorAvailability(selectedTopOption) {
    //console.log('Selected Top Option:', selectedTopOption);
    const flavorRadios = Array.from(this.topContainer.querySelectorAll('.variant-radio-buttons-drawer input[type="radio"]'));
    flavorRadios.forEach((radio) => {
      const flavor = radio.value;
      const isAvailable = this.variants.some(
        (variant) => variant.option1 === selectedTopOption && variant.option2 === flavor && variant.available
      );

      //console.log('Flavour:', flavor, 'Availability:', isAvailable);

      radio.disabled = !isAvailable;

      if (!isAvailable && radio.checked) {
        radio.checked = false;
      }
    });
  }


  onVariantChange(e) {
    super.onVariantChange(e);

    const sizeSelect = this.topContainer.querySelector('select[name="options[Size]"]')?.value;
    const servesSelect = this.topContainer.querySelector('select[name="options[Serves]"]')?.value;
    const servingSizeSelect = this.topContainer.querySelector('select[name="options[Serving Size]"]')?.value;

    const selectedTopOption = sizeSelect || servesSelect || servingSizeSelect;

    // Handle flavor availability based on the selected top option
    if (selectedTopOption) {
      this.handleFlavorAvailability(selectedTopOption);

      if (this.topContainer.querySelector('.variant-dropdown-container.open')) {
        this.closeAllDrawers();
        setTimeout(() => this.bindBackdropAndCloseEvents(), 10);
      }
    } else {
      console.warn('Neither Size nor Serves selected');
    }
  }

}

customElements.define('variant-dropdown-radios', VariantDropdownRadios);

Shopify.loadElements = function (data, selectors, parent = document) {
  Object.keys(selectors).forEach(key => {
    if (key[0] === '#') {
      data[key] = parent.getElementById(selectors[key].substring(1));
    }
    else if (key.slice(-1) === 's') {
      data[key] = parent.querySelectorAll(selectors[key]);
    }
    else {
      data[key] = parent.querySelector(selectors[key]);
    }
  });
};

Shopify.CountrySelector = function () {
  this.selectors = {
    countrySelectors: '[data-country-selector]',
    countrySelect: '.country-selector'
  };

  Shopify.loadElements(this, this.selectors);

  this.buildCountrySelectors()

};

Shopify.CountrySelector.prototype = {

  buildCountrySelectors: function () {
    const self = this;

    for (let i = 0; i < self.countrySelectors.length; i++) {
      let placeholder = self.countrySelectors[i];
      let selector = self.countrySelect.cloneNode(true);
      placeholder.appendChild(selector);
    }

  }

};

(new function () {
  document.addEventListener('DOMContentLoaded', function () {
    const bodyLoader = document.getElementById("bodyLoader");
    bodyLoader?.classList.add("hidden");

    waitForElm("#CartDrawer-Checkout").then((elm) => {
      elm.addEventListener("click", function (e) {
        bodyLoader.classList.remove("hidden");
      });
    });

    waitForElm(".shopify-cleanslate .DnvZqPMEvBFbBre5UuP9:not(.LVeInvZ5HcNOW1Zsn7NH)[role=button]").then((elm) => {
      elm.addEventListener("click", function () {
        bodyLoader.classList.remove("hidden");
      });
      return;//do not apply hover logic
      elm.addEventListener("mouseenter", function () {
        const svgIcon = document.getElementById("shopify-svg__payments-shop-pay");
        if (svgIcon) {
          svgIcon.classList.add("hover");
        }
      });
      elm.addEventListener("mouseleave", function () {
        const svgIcon = document.getElementById("shopify-svg__payments-shop-pay");
        if (svgIcon) {
          svgIcon.classList.remove("hover");
        }
      });
    });

    waitForElm(".rc-container-wrapper").then((elm) => {
      const title = document.querySelector(".product-form__title");
      title.style.display = "block";
    });

    waitForElm(".rc-widget").then((elm) => {
      function findWordWith(text, find) {
        const words = text.split(" ");
        for (const word of words) {
          if (word.includes(find)) {
            return word;
          }
        }
        return null;
      }

      const frequencyDiv = document.createElement('div');
      frequencyDiv.innerHTML = 'Frequency:';
      frequencyDiv.classList.add("product-form__title");
      elm.insertBefore(frequencyDiv, elm.firstChild);

      const subscriptionText = elm.querySelector(".rc-radio__label .rc-radio__subscription");
      const subscriptionPrice = elm.querySelector(".rc-radio__label .rc-radio__price");
      if (subscriptionText) {
        const percentOf = findWordWith(subscriptionText.textContent, "%");

        subscriptionText.textContent = subscriptionText.textContent.replace(/[0-9]*%/g, "");
        const subscription = subscriptionText.textContent;
        subscriptionText.innerHTML = `<span>${subscription}</span><span class="subtext">Delivery on your schedule</span>`;

        const price = subscriptionPrice.textContent;

        subscriptionPrice.innerHTML = `${price}<span class="subscription-badge">Save ${percentOf}</span>`;

      }
    });

  })

  function waitForElm(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

});

const countrySelector = new function () {
  class countrySelectoryCopier {
    constructor() {
      this.countrySelectorCopy = document.getElementById("countrySelectorWrapper");
      this.countrySelectorPaste = document.getElementById("countrySelectorPlaceholder");

      if (!this.countrySelectorCopy || !this.countrySelectorPaste)
        return;

      this.copy();
    }

    copy() {
      const html = this.countrySelectorCopy.innerHTML;
      this.countrySelectorPaste.innerHTML = html;
      this.countrySelectorCopy.remove();
    }
  }

  new countrySelectoryCopier();
}

  (new function () {

    addEventListeners();

    function addEventListeners() {
      document.addEventListener("DOMContentLoaded", function () {
        splitVideoDescriptions();
        splitCollectionDescriptions();
      });
    }

    const splitVideoDescriptions = function () {
      let longTexts = document.querySelectorAll(".video-section .video-description .content");
      let readMoreBtns = document.querySelectorAll("[data-video-desc-readmorebutton]");
      if (!longTexts || !readMoreBtns) return;

      textSplitter(longTexts, readMoreBtns, 50, 20);
    }

    const splitCollectionDescriptions = function () {
      let longTexts = document.querySelectorAll(".banner-category-header .banner-category-header__description .content");
      let readMoreBtns = document.querySelectorAll("[data-collection-desc-readmorebutton]");
      if (!longTexts || !readMoreBtns) return;

      textSplitter(longTexts, readMoreBtns, 30000, 15);
    }


    const textSplitter = function (longTexts, readMoreBtns, defaultTextMax = 50, mobileTextMax = 20) {
      let maxTextLength = defaultTextMax;
      let mql = window.matchMedia("(max-width: 750px)");
      if (mql.matches) {
        maxTextLength = mobileTextMax;
      }

      for (let i = 0; i < longTexts.length; i++) {
        let text = longTexts[i].innerText;
        let textArray = text.split(" ");
        if (textArray.length < maxTextLength) {
          readMoreBtns[i].classList.add("hidden");
          continue;
        }
        let firstHalf = textArray.slice(0, maxTextLength);
        let secondHalf = textArray.slice(maxTextLength, textArray.length);

        if (secondHalf.length == 0) {
          readMoreBtns[i].classList.add("hidden");
          continue;
        }

        longTexts[i].innerText = firstHalf.join(" ");
        longTexts[i].innerHTML += `<span class='secondHalf' style='display:none'> ${secondHalf.join(" ")} </span>`

        readMoreBtns[i].addEventListener("click", function () {
          let secondHalfEl = this.previousElementSibling.getElementsByClassName("secondHalf")[0];
          if (secondHalfEl.style.display === "none") {
            secondHalfEl.style.display = "inline";
            this.innerHTML = "Read Less";
          } else {
            secondHalfEl.style.display = "none";
            this.innerHTML = "Read More";
          }
        });
      }
    }
  })

$('body').on('click', '[href="#livechat"]', function () {
  if (GorgiasChat) {
    GorgiasChat.open();
  }
});

document.querySelector('#create_customer')?.addEventListener('submit', function () {
  var nameFirst = document.querySelector("#create_customer #RegisterForm-FirstName").value;
  var nameLast = document.querySelector("#create_customer #RegisterForm-LastName").value;
  if ((nameFirst == null || nameFirst == "" || nameFirst.length > 4)) {
    let formMessage = document.querySelector('.form__message');
    let errowField = "<p>Please fill in all fields</p>";
    formMessage.insertAdjacentHTML("afterend", errowField);
    return false;
  }

  if ((nameLast == null || nameLast == "" || nameLasе.length > 4)) {
    let formMessage = document.querySelector('.form__message');
    let errowField = "<p>Please fill in all fields</p>";
    formMessage.insertAdjacentHTML("afterend", errowField);
    return false;
  }
})

function checkedSubscription() {
  let newPrice = document.querySelector('label.rc-radio.rc-radio--active.subscription-radio.px-3.py-2 .rc-radio__price').innerHTML
  let newPrice2 = newPrice.split('')
  let priceFind = newPrice2.indexOf('<')
  let newPrice3 = newPrice2.slice(0, priceFind)
  let priceStr = newPrice3.join('')
  document.querySelectorAll('.price.price--large.price--show-badge span.price-item.price-item--regular')[0].innerText = priceStr;
  document.querySelector('.sticky-product-info--price span.price-item.price-item--regular').innerText = priceStr;
}

setTimeout(() => {

  let subscription = document.querySelector('.shopify-block.shopify-app-block.recharge-subscription-widget');
  if (subscription) {
    checkedSubscription();

    let radioInput1 = document.querySelector('input#rc-radio1');
    let radioInput2 = document.querySelector('input#rc-radio2');

    if(radioInput1){
      radioInput1.addEventListener("click", function () {
        document.querySelectorAll('.price.price--large.price--show-badge span.price-item.price-item--regular')[0].innerText = document.querySelector('.sticky-product-info--price span.price-item.price-item--regular').dataset.price;
        document.querySelector('.sticky-product-info--price span.price-item.price-item--regular').innerText = document.querySelector('.sticky-product-info--price span.price-item.price-item--regular').dataset.price;
      });
    }

    if(radioInput2){
      radioInput2.addEventListener("click", function () {
        let newPrice = document.querySelector('label.rc-radio.subscription-radio.px-3.py-2 .rc-radio__price').innerHTML
        let newPrice2 = newPrice.split('')
        let priceFind = newPrice2.indexOf('<')
        let newPrice3 = newPrice2.slice(0, priceFind)
        let priceStr = newPrice3.join('')
        document.querySelectorAll('.price.price--large.price--show-badge span.price-item.price-item--regular')[0].innerText = priceStr;
        document.querySelector('.sticky-product-info--price span.price-item.price-item--regular').innerText = priceStr;
      });
    }
  }

}, "2000");

$(function(){
  $("#data-account-menu-mobile").on("change", (e) => {
      let href = $(e.target).val();
      window.location.href = href;
  });

  function setMenu() {
    if (window.location.href.includes('account?view=orders')) {
      $("#data-account-menu-mobile").val('/account?view=orders')
    } else if (window.location.href.includes('/account/addresses')) {
      $("#data-account-menu-mobile").val('/account/addresses')
    } else if (window.location.href.includes('/account')) {
      $("#data-account-menu-mobile").val('/account')
    }
  }
  setMenu()

  setTimeout(function() {setMenu()}, 1000);
})


const checkCookie = async(cname) => {
  let name = await getCookie(cname);
  if (name != "") {
    return true
  }
  return false;
}

const getCookie = async (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

window.playConfetti = () => {
  const confettiWrapper = document.querySelector('.vault-promo__threshold-animation');
  if (confettiWrapper) {
    const path = confettiWrapper.getAttribute('data-path');
    const path_mobile = confettiWrapper.getAttribute('data-path-mobile') ?? null;

    const img = document.createElement('img');
    if (window.innerWidth < 768) {
      img.setAttribute('src', path_mobile);
    } else {
      img.setAttribute('src', path);
    }

    confettiWrapper.classList.remove('hidden');
    confettiWrapper.appendChild(img);

    setTimeout(() => {
        confettiWrapper.removeChild(img);
        confettiWrapper.classList.add('hidden');
    }, 3500);
  }
}

const canUpdatePromotionalWidget = async () => {
  const promoSection = document.querySelector('.sticky-promotion-section');
  if (!promoSection) return false;

  const promoMode = promoSection.dataset.promoMode || (window.tieredPromotionsConfig && window.tieredPromotionsConfig.mode);
  if (!promoMode || promoMode === 'disabled') return false;

  if (promoSection.dataset.tieredPromotions === 'standalone' || promoSection.classList.contains('promotions--standalone')) {
    return true;
  }

  if (promoSection.classList.contains('hidden')) return false;

  return !!(await checkCookie('ehp_vault1_access'));
};

const getTieredPromotionConfig = () => {
  return window.tieredPromotionsConfig || { mode: 'disabled', tiers: [] };
};

const getTieredPromotionTiers = () => {
  const config = getTieredPromotionConfig();

  if (!Array.isArray(config.tiers)) {
    return [];
  }

  return config.tiers;
};

const shouldUseSideCartTieredPromotionSync = () => {
  // The custom side cart is rendered globally in this theme and already owns the
  // post-mutation cart redraw, so other cart surfaces should not trigger a second sync.
  return typeof loadCartAPI === 'function';
};

const getTieredPromotionThresholdKey = (thresholdValue) => {
  const parsedThreshold = Number.parseFloat(thresholdValue);
  return Number.isFinite(parsedThreshold) ? String(parsedThreshold) : '';
};

const isManagedTierGiftItem = (item) => {
  return Boolean(item?.properties && Object.hasOwn(item.properties, '_gift-threshold'));
};

const getTieredPromotionQualifyingTotal = (cartData) => {
  // Managed gifts can retain a non-zero line price until Shopify applies their discount,
  // so eligibility must be based only on the customer's discounted merchandise spend.
  return cartData.items
    .filter((item) => !isManagedTierGiftItem(item))
    .reduce((total, item) => total + item.final_line_price, 0);
};

const getManagedTierGiftThreshold = (item) => {
  const thresholdKey = getTieredPromotionThresholdKey(item?.properties?.['_gift-threshold']);
  return thresholdKey === '' ? 0 : Number.parseFloat(thresholdKey);
};

const updateCartGiftLines = async (updates) => {
  const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ updates })
  });

  if (!response.ok) {
    throw new Error('Failed to update tiered promotion gifts.');
  }
};

const addTieredPromotionGift = async (item) => {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(item)
  });

  if (!response.ok) {
    throw new Error('Failed to add a tiered promotion gift.');
  }
};

let tieredPromotionSyncInFlight = false;

const syncTieredPromotionGifts = async (cartData, options = {}) => {
  const config = getTieredPromotionConfig();
  const tiers = getTieredPromotionTiers();
  const managedGiftItems = cartData.items.filter(isManagedTierGiftItem);
  const tieredPromotionsEnabled = config.mode !== 'disabled' && tiers.length > 0;
  const qualifyingTotal = getTieredPromotionQualifyingTotal(cartData);

  if (tieredPromotionSyncInFlight) {
    return false;
  }

  const updates = {};

  if (!tieredPromotionsEnabled) {
    managedGiftItems.forEach((item) => {
      updates[item.key] = 0;
    });

    if (Object.keys(updates).length === 0) {
      return {
        cartData,
        mutated: false
      };
    }
  }

  const claimedThresholds = new Set();
  if (tieredPromotionsEnabled) {
    managedGiftItems.forEach((item) => {
      const thresholdDollars = getManagedTierGiftThreshold(item);
      const itemThresholdKey = getTieredPromotionThresholdKey(thresholdDollars);
      const tier = tiers.find((promotionTier) => getTieredPromotionThresholdKey(promotionTier.thresholdDollars) === itemThresholdKey);
      const tierVariantId = Number.parseInt(tier?.variantId, 10);
      const cartVariantId = Number.parseInt(item.variant_id, 10);

      // Remove stale managed gifts when the tier is gone, the spend no longer qualifies,
      // or the cart still holds an older gift variant that is no longer the active tier gift.
      if (
        !tier
        || qualifyingTotal < tier.thresholdCents
        || !Number.isFinite(tierVariantId)
        || tierVariantId !== cartVariantId
      ) {
        updates[item.key] = 0;
        return;
      }

      claimedThresholds.add(itemThresholdKey);

      if (item.quantity > 1) {
        updates[item.key] = 1;
      }
    });
  }

  const additions = tieredPromotionsEnabled ? tiers
    .filter((tier) => qualifyingTotal >= tier.thresholdCents)
    .filter((tier) => Boolean(tier.variantId))
    .filter((tier) => !claimedThresholds.has(getTieredPromotionThresholdKey(tier.thresholdDollars)))
    .map((tier) => ({
      id: tier.variantId,
      quantity: 1,
      properties: {
        '_gift-threshold': String(tier.thresholdDollars)
      }
    })) : [];

  if (Object.keys(updates).length === 0 && additions.length === 0) {
    return {
      cartData,
      mutated: false
    };
  }

  tieredPromotionSyncInFlight = true;
  let syncedCartData = cartData;
  let mutationSucceeded = false;

  try {
    if (Object.keys(updates).length > 0) {
      await updateCartGiftLines(updates);
    }

    if (additions.length > 0) {
      // Add each unlocked gift in sequence so Shopify applies every threshold gift reliably
      // when multiple tiers are crossed in the same cart update.
      for (const addition of additions) {
        await addTieredPromotionGift(addition);
      }
    }

    if (options.reload === false) {
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
      if (!cartResponse.ok) {
        throw new Error('Failed to reload the cart after syncing tiered promotion gifts.');
      }

      syncedCartData = await cartResponse.json();
    }

    mutationSucceeded = true;
  } catch (error) {
    mutationSucceeded = false;
    console.error(error);
  } finally {
    tieredPromotionSyncInFlight = false;
  }

  if (mutationSucceeded && options.reload !== false) {
    // Let the active cart surface decide how to redraw itself after we mutate the cart.
    if (typeof options.onCartMutated === 'function') {
      await options.onCartMutated();
    } else if (typeof loadCartAPI === 'function') {
      loadCartAPI(false);
    } else {
      window.location.reload();
    }
  }

  return {
    cartData: syncedCartData,
    mutated: mutationSucceeded
  };
};

const updatePromotionalWidget = async (cartData) => {
  if (!(await canUpdatePromotionalWidget())) {
    return;
  }

  const cartItems = cartData.items;
  const qualifyingTotal = getTieredPromotionQualifyingTotal(cartData);
  const claimedThresholds = new Set(
    cartItems
      .filter(isManagedTierGiftItem)
      .map((item) => getTieredPromotionThresholdKey(getManagedTierGiftThreshold(item)))
  );

  const previousClaimedThresholds = new Set(
    Array.from(document.querySelectorAll('.gift-container.claimed:not(.gift-container--banner)'))
      .map((container) => getTieredPromotionThresholdKey(container.dataset.thresholdDollars))
      .filter(Boolean)
  );

  // Show/hide checkout button
  const checkoutBtn = document.querySelector('.promotional-widget a.checkout');
  if (checkoutBtn) {
    if (cartItems.length > 0) {
        checkoutBtn.classList.remove('hidden');
    } else {
      checkoutBtn.classList.add('hidden');
    }
  }

  // Update gift containers
  const giftContainers = document.querySelectorAll('.gift-container:not(.gift-container--banner)');
  giftContainers.forEach(container => {
    const qualifiedPrice = parseInt(container.dataset.qualifiedPrice, 10);
    const thresholdKey = getTieredPromotionThresholdKey(container.dataset.thresholdDollars);
    const tierClaimed = claimedThresholds.has(thresholdKey);
    const thresholdReached = qualifyingTotal >= qualifiedPrice;

    const remainingMessage = container.querySelector('.gift-info__remaining');
    if (remainingMessage) {
      if (tierClaimed) {
        remainingMessage.innerHTML = 'Completed';
      } else if (thresholdReached) {
        remainingMessage.innerHTML = 'Unlocked';
      } else {
        const remaining = ((qualifiedPrice - qualifyingTotal) / 100).toFixed(2);
        remainingMessage.innerHTML = `$${remaining} to go!`;
      }
    }

    container.classList.toggle('completed', thresholdReached);
    container.classList.toggle('claimed', tierClaimed);

    const giftCard = container.querySelector('.gift-card');
    if (giftCard) {
      giftCard.classList.toggle('claimed', tierClaimed);
    }

  });

  // Update progress bar display
  const progressFill = document.querySelector('.progress-fill');
  if (progressFill) {
    let largestGoal = progressFill.dataset.largestGoal;
    progressFill.style.width = `${Math.min(qualifyingTotal / largestGoal * 100, 100)}%`;
  }

  // Update progress bar button displays
  const progressButtons = document.querySelectorAll('.progress-bar .step');
  progressButtons.forEach(button => {
    const qualifiedPrice = parseInt(button.dataset.qualifiedPrice, 10);
    button.classList.toggle('claimed', qualifyingTotal >= qualifiedPrice);
  });

  if (typeof window.updateGorgiasChatPosition === 'function') {
    window.updateGorgiasChatPosition();
  }

  // play confetti animation and reveal banner if a target is unlocked
  const newlyClaimedThresholds = getTieredPromotionTiers()
    .map((tier) => getTieredPromotionThresholdKey(tier.thresholdDollars))
    .filter((thresholdKey) => claimedThresholds.has(thresholdKey) && !previousClaimedThresholds.has(thresholdKey));

  if (newlyClaimedThresholds.length === 0) {
    return false;
  }

  window.playConfetti();

  const banners = document.querySelectorAll('.gift-container--banner');
  let showingBannerPopup = false;
  const bannerThreshold = newlyClaimedThresholds[0];
  banners.forEach(banner => {
    if (getTieredPromotionThresholdKey(banner.dataset.thresholdDollars) === bannerThreshold) {
      showingBannerPopup = true;

      banner.classList.remove('hidden');
      banner.classList.add('fade-in');
      setTimeout(() => {
        banner.classList.remove('fade-in');
        banner.classList.add('fade-out');
      }, 2000);
      setTimeout(() => {
        banner.classList.add('hidden');
        banner.classList.remove('fade-out');
      }, 3500);
    }
  })

  if (showingBannerPopup) {
    return true;
  } else {
    return false;
  }
}

const addProductToCartById = (productId, qty, buttonElement = null , properties = {}) => {
  let originalButtonText;
  if (buttonElement instanceof HTMLElement) {
    originalButtonText = buttonElement.innerText;
    buttonElement.disabled = true; // Disable button
    buttonElement.textContent = "Adding..."; // Set loading state text
  }

  // Add to cart via Shopify ajax api
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: productId,
      quantity: qty,
      properties: properties
    })
  })
  .then(response => {
    let data = response.json();
    if (!response.ok) {
      throw new Error(`Error adding to cart: You already have the maximum 3 allowed`);
    }
    return data;
  })
  .then(data => {
    if (buttonElement.classList.contains('promotion-add-to-cart-btn')) {
      // Don't show popup for promo gift auto add
      loadCartAPI(false);
    } else {
      loadCartAPI(true);
    }
  })
  .catch(error => {
    console.error('Error:', error);
    // alert(error);
  })
  .finally(() => {
    if (buttonElement instanceof HTMLElement) {
      buttonElement.disabled = false; // Re-enable button
      buttonElement.textContent = originalButtonText; // Reset button text
    }
  });
}

const removeKeysFromCart = (keysToRemove) => {
  const updates = keysToRemove.reduce((obj, key) => {
    obj[key] = 0;
    return obj;
  }, {});

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ updates })
  })
  .then((response) => {
    if (!response.ok) {
      throw new Error('Failed to update the cart');
    }
  })
  .then((updatedCart) => {
    console.log('Updated cart:', updatedCart);
    loadCartAPI();
  })
  .catch((error) => {
    console.error('Error updating cart:', error);
    throw error;
  });
}

const reduceKeysInCart = (keysToReduce) => {
  const updates = keysToReduce.reduce((obj, key) => {
    obj[key] = 1;
    return obj;
  }, {});

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ updates })
  })
  .then((response) => {
    if (!response.ok) {
      throw new Error('Failed to update the cart');
    }
  })
  .then((updatedCart) => {
    console.log('Updated cart:', updatedCart);
    loadCartAPI();
  })
  .catch((error) => {
    console.error('Error updating cart:', error);
    throw error;
  });
}

const validateGiftsInCart = (cartData) => {
  return syncTieredPromotionGifts(cartData);
}

document.addEventListener("DOMContentLoaded", function () {
  if (typeof syncTieredPromotionGifts === 'function') {
    // Run one background validation on every page load so stale threshold gifts are
    // cleaned up even when the customer lands on /cart or another cart surface first.
    fetch(`${window.Shopify.routes.root}cart.js`)
      .then((cartResponse) => cartResponse.json())
      .then((cartData) => syncTieredPromotionGifts(cartData))
      .catch((error) => console.error(error));
  }

  document.addEventListener('click', (event) => {
    const minusBtn = event.target.closest('.qty-btn.minus');
    const plusBtn = event.target.closest('.qty-btn.plus');
    const addToCartBtn = event.target.closest('.add-to-cart');
    const giftAddToCartBtn = event.target.closest('.promotion-add-to-cart-btn');

    if (minusBtn) {
      const container = minusBtn.closest(".qty-cart-container");
      const qtyInput = container.querySelector(".qty-input");
      let currentValue = parseInt(qtyInput.value, 10);
      if (currentValue > 1) {
        qtyInput.value = currentValue - 1;
      }
    }

    if (plusBtn) {
      const container = plusBtn.closest(".qty-cart-container");
      const qtyInput = container.querySelector(".qty-input");
      let currentValue = parseInt(qtyInput.value, 10);
      if (currentValue < 3) {
        qtyInput.value = currentValue + 1;
      }
    }

    if (addToCartBtn) {
      const container = addToCartBtn.closest(".qty-cart-container");
      const qtyInput = container.querySelector(".qty-input");
      let currentValue = parseInt(qtyInput.value, 10);
      let productId = addToCartBtn.dataset.productId;
      addProductToCartById(productId, currentValue, addToCartBtn );
    }

    if (giftAddToCartBtn) {
      let productId = giftAddToCartBtn.dataset.productId;
      if (!productId) return;
      let thresholdDollars = giftAddToCartBtn.dataset.thresholdDollars;
      let properties = {
        "_gift-threshold": thresholdDollars,
      };
      addProductToCartById(productId, 1, giftAddToCartBtn, properties);
    }
  });

  $(document).on('change', '.vault-variant-selector', (e) => {
    const select = e.currentTarget;

    const varId = select.options[select.selectedIndex].value;
    if (!varId) return;

    const parent = select.closest('.card__quick-add');
    if (!parent) return;

    const atcBtn = parent.querySelector('.add-to-cart');
    if (!atcBtn) return;

    atcBtn.setAttribute('data-product-id', varId);
  })
});
